export default "__VITE_ASSET__BUcyMmQZ__"